import React, {useState} from 'react'
import {motion} from 'framer-motion';
import {format} from 'timeago.js'
import axios from 'axios';

import LoadinAndSendData from '../../utils/loadingSendReceiveData/loadingSendReceiveData'

import URL from '../../config/config-server-api'
import './editProduct.css'

const EditProduct = ({product, UpdataEdited ,clouseModal, modal, itemProduct }) =>{

    const [DataProduct, setDataProduct] = useState(product)

    const [imagePosition, setImagePosition] = useState(1);
    const [srcFileImage, setSrcFileImage]= useState('');
    const [fileImage, setFileImage] = useState('');

    const [stateSpinner, setSatatSpinner]=useState(false)

    const handlePositionImage =(e)=>{
        console.log(e.target.value)
        var numberImage = e?.target?.value
        setImagePosition(numberImage)

    }

    const handleFileImage =(e)=>{
        // console.log(e)
        // console.log(e.target)
        // console.log(e.target.files)
        // console.log(e.target.files[0].size)
        // console.log((e.target.files[0].size/(1024*1024)).toFixed(2))
        const fileSize = e?.target?.files[0]?.size;

        
        if(fileSize && fileSize >= 20000 ){
            console.log("Tamano del archivo aceptado")
            console.log(e.target.files[0].name)
            const srcFile = e?.target?.files[0];
            let reader = new FileReader();

            setFileImage(srcFile);

            reader.onload=()=>{
                if(reader.readyState === 2){
                    setSrcFileImage(reader.result)
                }
            }
            reader.readAsDataURL(srcFile)
        }

    }

    const handleChange =(e)=>{
        console.log(e.target.value)
        
        setDataProduct({
            ...DataProduct,
            [e.target.name]:e.target.value
        })

    }

    const handleChangeCostoEnvio=(e)=>{
        console.log(e.target.value)
        

        if(e.target.name ==="tipoEnvio" && e.target.value==="gratuito"){
            setDataProduct({
                ...DataProduct,
                [e.target.name]:e.target.value,
                costoEnvio:'0'
            })
       
        }else{
            setDataProduct({
                ...DataProduct,
                [e.target.name]:e.target.value
            })
        }
    }

    

    const sentData =()=>{
        console.log('send data');

        setSatatSpinner(true)
        const url =  URL.UrlUpdateDataProduct + DataProduct._id;

        const params ={
            method:'PUT',
            url:url,
            data: JSON.stringify(DataProduct),
            headers:{
                'Content-Type':'application/json'
            }
        }
        axios(params)
        .then(data=>{
            console.log(data)
            if(data.status==200){
                // UpdataEdited({DataProduct})
                UpdataEdited({DataProduct:data.data.productoUpdeted})
                console.log('se guardaron  los datos')
                setSatatSpinner(false)
            }
        })
        .catch(err=>{
            console.log(err.response)
        })

        console.log(url);


    }


    return(
        <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{duration:0.3}} id="modalEditProduct" className="">
            <motion.div key={modal} exit={{opacity:0, y:-300}}   initial={{opacity:0, y:200}} animate={{opacity:1,y:0}} id="container-form" className="rounded-xl mx-auto bg-white container mt-20 h-auto w-11/12 sm:w-3/4 lg:w-2/4">
            <div className="flex flex-row-reverse mt-2 "><span onClick={()=>clouseModal()} className="font-bold cursor-pointer px-2">X</span></div>
               
               {
                   stateSpinner?
                   <LoadinAndSendData></LoadinAndSendData>
                   :
                   ''
               }
            
                <div className="text-center  text-xl font-bold"> { DataProduct.nameProduct } </div>
                <div id="content-form-adit-product" className=" p-2 pb-10 mb-20 sm:px-9 py-5 grid grid-row-1">

                    <label htmlFor="nameProduc" className="font-medium text-sm  text-gray-400">Nombre del producto o servicio :</label>
                    <input type="text" onChange={(e)=>handleChange(e)} name="nameProduct" value={DataProduct.nameProduct} className="px-2 border border-green-300 rounded-2xl  rounded-2xl  focus:outline-none  focus:border-green-500 focus:z-10 mb-3"/>

                    <label htmlFor="Nombre del neocio" className="font-medium text-sm  text-gray-400">Nombre de la tienda : </label>
                    <input type="text" className="px-2 border border-green-300 rounded-2xl  focus:outline-none  focus:border-green-500 focus:z-10 mb-2"
                    name="nameTienda" 
                    onChange={(e)=>handleChange(e)} 
                    value={DataProduct.nameTienda} />
                    
                    <div className="flex flex-col block text-sm font-medium text-gray-400 mb-2">
                                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Envios desde : <span className="font-medium text-sm  text-gray-400"> (lugar de donde se realiza las ventas)</span> : </label>
                                        
                                        <select name="envioDesde" onChange={(e)=>handleChange(e)} type="text" id="nameTienda" placeholder="Potosi" 
                                        className="px-2 py-1  text-gray-900 focus:outline-none border focus:border focus:ring-indigo-500  focus:border-green-500 border-green-300 rounded-2xl" >
                                               <option disabled selected hidden value={DataProduct.envioDesde===""?"":DataProduct.envioDesde} className="">{DataProduct.envioDesde===""?"Sin Seleccionar":DataProduct.envioDesde}</option> 
                                               <option value="potosi">Potosi</option> 
                                               <option value="chuquisaca">Chuquisaca</option>
                                               <option value="santa cruz">Santa Cruz</option>
                                               <option value="la paz">La Paz</option> 
                                               <option value="oruro">Oruro</option> 
                                               <option value="pando">Pando</option> 
                                               <option value="tarija">Tarija</option> 
                                               <option value="beni">Beni</option>
                                               <option value="cochabamba">Cochabamba</option>
                                               <option value="otros">Otros</option> 
                                        </select> 
                    </div>

                    <div className="flex flex-col block text-sm font-medium text-gray-400 mb-2">
                                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Tipo de envio : <span className="font-medium text-sm  text-gray-400"> (gratuito, con costo)</span> : </label>
                                        
                                        <select name="tipoEnvio" onChange={(e)=>handleChangeCostoEnvio(e)} type="text" id="nameTienda" placeholder="Potosi" 
                                        className="px-2 py-1  text-gray-900 focus:outline-none border focus:border focus:ring-indigo-500  focus:border-green-500 border-green-300 rounded-2xl" >
                                               <option value={DataProduct.tipoEnvio===""?"":DataProduct.tipoEnvio} className="">{DataProduct.tipoEnvio===""?"Sin Seleccionar":DataProduct.tipoEnvio}</option> 
                                               <option value="gratuito">Gratuito</option> 
                                               <option value="con costo">Con costo</option>
                                        </select> 
                    </div>

                    {
                        DataProduct?.tipoEnvio==="con costo"?
                        <motion.div initial={{opacity:0, y:12}} animate={{opacity:1,y:0}} className="flex flex-col">
                            <label htmlFor="costoDeEnvios" className=" font-medium text-sm  text-gray-400">Costo de envio: </label>
                            <input type="number" 
                            name="costoEnvio"
                            onChange={(e)=>handleChange(e)} 
                            className="px-2 rounded-2xl  border border-green-300 focus:outline-none mb-2" 
                            value={DataProduct.costoEnvio} />
                        </motion.div>
                        :
                        ''
                    }
                    
                    <div className="flex flex-col block text-sm font-medium text-gray-400">
                        <label htmlFor="nameTienda" htmlFor="#NombreDeLaTienda">Colores disponibles <span className="font-medium text-sm  text-gray-400"> (Color del producto)</span> : </label>

                        <select name="colorsAvailable" onChange={(e)=>handleChange(e)} type="text" id="nameTienda" placeholder="Potosi" 
                        className="px-2 py-1 mt-1 text-gray-700 focus:outline-none border rounded-2xl focus:ring-green-500  focus:border-green-500 border-green-300 rounded-md mb-2" >
                                <option value={DataProduct.colorsAvailable===""?"":DataProduct.colorsAvailable} className="">{DataProduct.colorsAvailable===""?"Sin Seleccionar":DataProduct.colorsAvailable}</option> 
                                <option value="color de la foto">Color de la foto</option> 
                                <option value="amarillo">Amarillo</option>
                                <option value="ambar">Ambar</option>
                                <option value="anil o indigo">Añil o indigo</option>
                                <option value="azul">Azul</option>
                                <option value="azul claro">Azul claro</option>
                                <option value="azul eléctrico">Azul eléctrico</option>
                                <option value="azul marino">Azul marino</option>
                                <option value="beis">Beis</option>
                                <option value="bermellon">Bermellon</option>
                                <option value="blanco">Blanco</option>
                                <option value="blanco marfil">Blanco marfil</option>
                                <option value="burdeos">Burdeos</option>
                                <option value="cafe">Cafe</option>
                                <option value="caoba o rojo indio">Caoba o rojo indio</option>
                                <option value="caqui">Caqui</option>
                                <option value="carmesi">Carmesi</option>
                                <option value="castano">Castano</option>
                                <option value="celeste">Celeste</option>
                                <option value="cereza">Cereza</option>
                                <option value="champan">Champan</option>
                                <option value="chartreuse o cartujo">Chartreuse o cartujo</option>
                                <option value="cian">Cian</option>
                                <option value="cobre">Cobre</option>
                                <option value="color terracota o teja">Color terracota o teja</option>
                                <option value="coral">Coral</option>
                                <option value="crema">Crema</option>
                                <option value="fucsia">fucsia</option>
                                <option value="granate">Granate</option>
                                <option value="gris">Gris</option>
                                <option value="gris perla">Gris perla</option>
                                <option value="gris zinc">Gris zinc</option>
                                <option value="gualdo">Gualdo</option>
                                <option value="hueso">Hueso</option>
                                <option value="lavanda">Lavanda</option>
                                <option value="lila">Lila</option>
                                <option value="magenta">Magenta</option>
                                <option value="marron">Marrón</option>
                                <option value="marron chocolate">Marron chocolate</option>
                                <option value="morado">Morado</option>
                                <option value="naranja">Naranja</option>
                                <option value="negro">Negro</option>
                                <option value="ocre">Ocre</option>
                                <option value="ocre claro">Ocre claro</option>
                                <option value="ocre oscuro">Ocre oscuro</option>
                                <option value="oro o dorado">Oro o dorado</option>
                                <option value="pardo">Pardo</option>
                                <option value="plata">Plata</option>
                                <option value="plomo">Plomo</option>
                                <option value="purpura">Purpura</option>
                                <option value="rojo">Rojo</option>
                                <option value="rojo carmin">Rojo carmin</option>
                                <option value="rojo oxido">Rojo oxido</option>
                                <option value="rosa">Rosa</option>
                                <option value="rosa palo">Rosa palo</option>
                                <option value="salmon">Salmon</option>
                                <option value="turquesa">Turquesa</option>
                                <option value="verde">Verde</option>
                                <option value="verde botella">Verde botella</option>
                                <option value="verde esmeralda">Verde esmeralda</option>
                                <option value="verde lima">Verde lima</option>
                                <option value="verde manzana">Verde manzana</option>
                                <option value="verde musgo">Verde musgo</option>
                                <option value="verde oliva">Verde oliva</option>
                                <option value="verde pistacho">Verde pistacho</option>
                                <option value="verdeagua o aguamarina">Verdeagua o aguamarina</option>
                                <option value="violeta">Violeta</option>
                                <option value="vino">Vino</option>
                        </select>
                    </div>

                    <label htmlFor="estadoProduct" className="font-medium text-sm  text-gray-400">Estado del producto : </label>
                    <select type="text"
                    name="estadoProduct"
                    onChange={(e)=>handleChange(e)} 
                    className="px-2 mb-2 border  border-green-300 rounded-2xl  focus:outline-none focus:border-green-500"
                    >
                            <option value={DataProduct.estadoProduct===""?"": DataProduct.estadoProduct}>{DataProduct.estadoProduct===""?"Seleccione una opción":DataProduct.estadoProduct}</option>
                            <option value="nuevo">Nuevo</option>
                            <option value="usado">Usado</option>
                            <option value="caja abierta">De caja abierta</option>
                    </select>

                    <label htmlFor="Direccion" className="font-medium text-sm  text-gray-400">Piezas dispobles (unidades): </label>
                    <input type="number" 
                    name="piezasDiponibles"
                    onChange={(e)=>handleChange(e)} 
                    className="px-2 mb-2 border border-green-300 rounded-2xl  focus:outline-none focus:border-green-500"
                    value={DataProduct.piezasDiponibles} />

                    <label htmlFor="Telefono" className="font-medium text-sm  text-gray-400">Precio anterior : </label>
                    <input type="number" 
                    name="priceBefore"
                    onChange={(e)=>handleChange(e)} 
                    className="px-2 mb-2 border border-green-300 rounded-2xl  focus:outline-none focus:border-green-500"
                    value={DataProduct.priceBefore} />

                    <label htmlFor="Descripcion" className="font-medium text-sm  text-gray-400">Precio de venta : </label>
                    <input rows="4" cols="50" type="number" 
                        //  priceCurrent
                    name="priceCurrent"
                    onChange={(e)=>handleChange(e)} 
                    className="mb-2 border border-green-300 rounded-2xl pl-2 w-full  focus:outline-none focus:border-green-500"
                    value={DataProduct.priceCurrent} />

                    <label htmlFor="Descripcion" className="font-medium text-sm  text-gray-400">Marca del producto : </label>
                    <input rows="4" cols="50" type="text" 
                    name="marcaproduct"
                    onChange={(e)=>handleChange(e)} 
                    className="mb-2 border border-green-300 rounded-2xl pl-2 w-full  focus:outline-none focus:border-green-500"
                    value={DataProduct.marcaproduct} />

                    <label htmlFor="Descripcion" className="font-medium text-sm  text-gray-400">Descripción del procuto o servicio: </label>
                    <textarea rows="4" cols="50" type="text" 
                    name="descripcion"
                    onChange={(e)=>handleChange(e)} 
                    className="mb-2 border border-green-300 rounded-2xl pl-2 w-full  focus:outline-none focus:border-green-500"
                    value={DataProduct.descripcion} />

                    
                    <label htmlFor="Fecha de creacion" className="font-medium text-sm  text-gray-400">Fecha de Creación : </label>
                    <span type="text"
                    name="fechaRegistro"
                    onChange={(e)=>handleChange(e)} 
                    value={format(DataProduct.fechaRegistro,"es_ES")} >{format(DataProduct.fechaRegistro,"es_ES")}</span> <br/>

                    {/* upload file logotipo */}
                    {/* <div>
                        <label htmlFor="selectImage">Seleccione el numero de la imagen:</label>
                        <select onChange={handlePositionImage} className="border border-indigo-300 text-sm text-indigo-800 ml-3 px-2 rounded-2xl focus:outline-none" name="selectImage" id="">
                            <option value="1">Imagen 1</option>
                            <option value="2">Imagen 2</option>
                            <option value="3">Imagen 3</option>
                            <option value="4">Imagen 4</option>
                        </select>
                    </div> */}
                    <div className="pt-4">
                    <label className="block text-sm font-medium text-gray-700">Foto o imagen del prorducto o servicio</label>
                    <div style={{backgroundImage:`url(${srcFileImage})`}} className=" mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                        <div className="space-y-1 text-center">
                        <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                            <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <div className="flex text-sm text-gray-600">
                            <label htmlFor="file-upload" className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                <span className="mr-0">Seleccione una imagen</span>
                                <input onChange={handleFileImage} id="file-upload" name="file-upload" type="file" accept="image/*" className="sr-only"/>
                            </label>
                            {/* <p className="pl-1">o arrastrar y soltar</p> */}
                        </div>
                        <p className="text-xs text-gray-500">
                            PNG, JPG, GIF. tamaño maximo 5MB
                        </p>
                        </div>
                    </div>
                    </div>
                    {srcFileImage?<img src={srcFileImage} id="preview" alt="" width="100" height="100" />:''}
                    {/* ------------------- */}
            
                    <div className="grid justify-items-center mt-10">
                        <button onClick={sentData} className=" w-1/2 bg-green-400 hover:bg-green-500 text-white font-semibold rounded-lg focus:outline-none">Guradar cambios</button>
                    </div>        
                </div>
                         
                    
             
            </motion.div>
        </motion.div>
    );
}


export default EditProduct;